class PerformanceTest {
	static get performanceVariants() {
		return [
			'not-available-performance',
			'low-performance',
			'average-performance',
			'high-performance'
		];
	}

	static install(Vue, options) {
		let testScore = PerformanceTest.markPerformance();
		Vue.prototype.$performance = {
			variant: PerformanceTest.performanceVariants[testScore],
			level: testScore,
		};
	}

	static performanceTest() {
		try {
			if (window.performance && window.performance.memory) {
				if (performance.memory.jsHeapSizeLimit >= 1073741824) {
					return 3;
				} else if (performance.memory.jsHeapSizeLimit >= 536870912) {
					return 2;
				} else return 1;
			} else {
				console.warn('Performance test not available');
			}
		} catch (e) {
			console.warn(e);
		}
		return 0;
	}

	static markPerformance() {
		let performanceScore = PerformanceTest.performanceTest();
		window.document.body.classList.add(PerformanceTest.performanceVariants[performanceScore]);
		return performanceScore;
	}
}

export default PerformanceTest;